import { getAuthToken } from "../utils/auth";
import { config } from '../config';

export async function UnlockAccount(token) {
  const response = await fetch(config.apiBaseUrl + '/rest/accounts/unlock', {
    method: 'PUT',
    headers: {
      'content-type': 'application/json'
    },
    body: JSON.stringify({token: token})
  })

  if (response.status === 400 || response.status === 404) {
    return response
  }

  if (response.status >= 500) {
    throw Response.json({ message: 'Something went wrong' }, { status: 500 })
  }

  return null
}

export async function RequestPasswordRecoveryAccount(email, recaptchaToken) {
  const requestPasswordRecoveryData = {
    email: email,
    captcha_token: recaptchaToken
  }

  const response = await fetch(config.apiBaseUrl + '/rest/accounts/password/recover', {
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    },
    body: JSON.stringify(requestPasswordRecoveryData)
  })

  if (response.status >= 500) {
    throw Response.json({ message: 'Something went wrong' }, { status: 500 })
  }

  return { success: 'OK' }
}

export async function RecoverPasswordAccount(formData) {
  const response = await fetch(config.apiBaseUrl + '/rest/accounts/password/recover', {
    method: 'PUT',
    headers: {
      'content-type': 'application/json'
    },
    body: JSON.stringify(formData)
  })

  if (response.status >= 400 && response.status <= 499) {
    return response
  }

  if (response.status >= 500) {
    throw Response.json({ message: 'Something went wrong' }, { status: 500 })
  }

  return { success: 'OK' }
}

export async function ConfirmAccount(token) {
  const response = await fetch(config.apiBaseUrl + '/rest/accounts/confirm', {
    method: 'PUT',
    headers: {
      'content-type': 'application/json'
    },
    body: JSON.stringify({token: token})
  })

  if (response.status === 400 || response.status === 404) {
    return response
  }

  if (!response.ok) {
    throw Response.json({ message: 'Something went wrong' }, { status: 500 })
  }

  return null;
}

export async function ResendConfirmationEmailAccount(email, recaptchaToken) {
  const response = await fetch(config.apiBaseUrl + '/rest/accounts/confirm/resend', {
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    },
    body: JSON.stringify({ email: email, captcha_token: recaptchaToken })
  })

  return { data: 'ok', status: response.status }
}

export async function UpdatePasswordAccount(passwords) {
  const token = getAuthToken();
  const response = await fetch(`${config.apiBaseUrl}/rest/accounts/password/update`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify(passwords)
  });

  if (response.status >= 500) {
    throw new Error("Failed to update user's password");
  }

  return { status: response.status, ...(await response.json()) };
}

